import React from 'react'
import { Area, AreaChart, CartesianGrid, ResponsiveContainer, Tooltip } from 'recharts'
import { DashboardCardWrapper } from '../../commonComponents/DashboardCardWrapper'

const comparisonData = [
    { month: 'Jan', thisMonth: 68000, lastMonth: 52000 },
    { month: 'Feb', thisMonth: 72000, lastMonth: 58000 },
    { month: 'Mar', thisMonth: 81000, lastMonth: 64000 },
    { month: 'Apr', thisMonth: 76000, lastMonth: 61000 },
    { month: 'May', thisMonth: 92000, lastMonth: 73000 },
    { month: 'Jun', thisMonth: 88000, lastMonth: 70000 },
]

export const ComparisonChart = () => {
    return (
        <DashboardCardWrapper
            headerText={'Financial Comparison'}
            componentStyles={{ width: '35%', position: 'relative' }}
        >
            <div className='px-1' style={{ width: '100%', height: '320px', position: 'absolute', bottom: 35, left: 0 }}>
                <ResponsiveContainer width='100%' height='100%'>
                    <AreaChart
                        data={comparisonData}
                        margin={{ top: 20, right: 0, left: 0, bottom: 0 }}
                    >
                        <defs>
                            <linearGradient id='thisMonthGradient' x1='0' y1='0' x2='0' y2='1'>
                                <stop offset='0%' stopColor='#22C55E' stopOpacity={0.35} />
                                <stop offset='100%' stopColor='#22C55E' stopOpacity={0.03} />
                            </linearGradient>

                            <linearGradient id='lastMonthGradient' x1='0' y1='0' x2='0' y2='1'>
                                <stop offset='0%' stopColor='#84CC16' stopOpacity={0.22} />
                                <stop offset='100%' stopColor='#84CC16' stopOpacity={0.02} />
                            </linearGradient>
                        </defs>

                        <CartesianGrid
                            horizontal={false}
                            vertical
                            stroke='#E5E7EB'
                            strokeDasharray='0'
                        />

                        <Tooltip
                            cursor={{ stroke: '#D1D5DB', strokeWidth: 1 }}
                            formatter={(value, name) => [
                                `₹${Number(value).toLocaleString()}`,
                                name === 'thisMonth' ? 'This Month' : 'Last Month',
                            ]}
                        />

                        <Area
                            type='monotone'
                            dataKey='lastMonth'
                            stroke='#84CC16'
                            strokeWidth={2}
                            fill='url(#lastMonthGradient)'
                            dot={false}
                            activeDot={{ r: 4 }}
                        />

                        <Area
                            type='monotone'
                            dataKey='thisMonth'
                            stroke='#22C55E'
                            strokeWidth={3}
                            fill='url(#thisMonthGradient)'
                            dot={false}
                            activeDot={{ r: 5 }}
                        />
                    </AreaChart>
                </ResponsiveContainer>
            </div>
            <div
                style={{
                    position: 'absolute',
                    bottom: 10,
                    left: "30%",
                    display: 'flex',
                    alignItems: 'center',
                    gap: '20px',
                    fontSize: '12px',
                    fontWeight: 500,
                }}
            >
                <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                    <span
                        style={{
                            width: '8px',
                            height: '8px',
                            borderRadius: '50%',
                            background: '#22C55E',
                            display: 'block',
                        }}
                    />
                    <span>This Month</span>
                </div>

                <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                    <span
                        style={{
                            width: '8px',
                            height: '8px',
                            borderRadius: '50%',
                            background: '#84CC16',
                            display: 'block',
                        }}
                    />
                    <span>Last Month</span>
                </div>
            </div>
        </DashboardCardWrapper>
    )
}
